<template>
  <div class="modal-overlay">
    <div class="modal-container">
      <div class="modal-header">
        <h5>Renovação antecipada</h5>
        <button class="btn-close" @click="$emit('cancel')"></button>
      </div>

      <div class="modal-body">
        <p class="mb-3">
        Esta matrícula está sendo renovada com <strong>{{ props.diasAntecedencia }} dias</strong> de antecedência.
        Selecione o brinde ou desconto por antecipação:
        </p>

        <!-- SELECT DE BRINDE -->
        <div class="mb-3">
          <label class="form-label">Brinde</label>
          <select class="form-control" v-model="brindeSelecionadoId" @change="onBrindeChange">
            <option value="" disabled>Selecione</option>
            <option v-for="b in brindes" :key="b.id" :value="String(b.id)">
              {{ b.nome }}
            </option>
            <option value="__OUTRO__">Outro brinde</option>
            <option value="__DESCONTO__">Desconto por antecipação</option>
          </select>
        </div>

        <!-- OUTRO BRINDE -->
        <div class="mb-3" v-if="isOutroBrinde">
          <label class="form-label">Descreva o brinde</label>
          <input type="text" class="form-control" v-model.trim="outroBrindeTexto" placeholder="Ex.: Camiseta exclusiva" />
        </div>

        <!-- SELECT DE DESCONTOS -->
        <div class="mb-3" v-if="isDesconto">
          <label class="form-label">Selecione o desconto</label>
          <select class="form-control" v-model="descontoSelecionadoId">
            <option value="" disabled>Selecione</option>
            <option v-for="d in descontos" :key="d.id" :value="String(d.id)">
              {{ d.descricao }} ({{ fmtPercent(d.desconto) }})
            </option>
          </select>
        </div>

        <div v-if="erro" class="alert alert-danger py-2">{{ erro }}</div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-secondary" @click="$emit('cancel')">Cancelar</button>
        <button class="btn btn-primary" @click="confirmar">Confirmar</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import axios from '@/services/axios'

const props = defineProps({
  diasAntecedencia: { type: Number, default: 0 }
})

const brindes = ref([])
const descontos = ref([])
const brindeSelecionadoId = ref('')
const descontoSelecionadoId = ref('')
const outroBrindeTexto = ref('')
const erro = ref('')

const isOutroBrinde = computed(() => brindeSelecionadoId.value === '__OUTRO__')
const isDesconto    = computed(() => brindeSelecionadoId.value === '__DESCONTO__')

function fmtPercent(v){
  if (v == null) return ''
  const n = Number(v)
  return `${n.toLocaleString('pt-BR', { minimumFractionDigits:2, maximumFractionDigits:2 })}%`
}

function onBrindeChange(){
  erro.value = ''
  if (!isOutroBrinde.value) outroBrindeTexto.value = ''
  if (!isDesconto.value)    descontoSelecionadoId.value = ''
}

async function carregarBrindes(){
  const { data } = await axios.get('/cadastros/brindes', { params: { ativo: true, limit: 100 } })
  const arr = data?.data || data || []
  brindes.value = Array.isArray(arr) ? arr.filter(b => b.ativo === true) : []
}

async function carregarDescontos(){
  const { data } = await axios.get('/cadastros/descontos', { params: { ativo: true, limit: 100 } })
  descontos.value = data?.data || data || []
}

function validar(){
  if (!brindeSelecionadoId.value){
    erro.value = 'Selecione um brinde ou o “Desconto por antecipação”.'
    return false
  }
  if (isOutroBrinde.value && !outroBrindeTexto.value){
    erro.value = 'Descreva o brinde.'
    return false
  }
  if (isDesconto.value && !descontoSelecionadoId.value){
    erro.value = 'Selecione o desconto.'
    return false
  }
  return true
}

const emit = defineEmits(['confirm','cancel'])

function confirmar(){
  if (!validar()) return

  if (isDesconto.value){
    const d = descontos.value.find(x => String(x.id) === descontoSelecionadoId.value)
    const payload = {
      tipo: 'desconto',
      descontoId: d?.id ?? null,
      descontoDescricao: d?.descricao ?? '',
      descontoPercentual: d?.desconto ?? null,
      observacao: `Brinde de renovação antecipada: Desconto por antecipação - ${d?.descricao || ''}`
    }
    emit('confirm', payload)
  } else {
    let nome
    if (isOutroBrinde.value){
      nome = (outroBrindeTexto.value || '').trim()
    } else {
      const b = brindes.value.find(x => String(x.id) === brindeSelecionadoId.value)
      nome = b?.nome || ''
    }
    const payload = {
      tipo: 'brinde',
      brindeId: isOutroBrinde.value ? null : Number(brindeSelecionadoId.value),
      brindeNome: nome,
      observacao: `Brinde de renovação antecipada: ${nome}`
    }
    emit('confirm', payload)
  }
}

onMounted(async () => {
  await Promise.all([carregarBrindes(), carregarDescontos()])
})
</script>

<style scoped>
.modal-overlay{ position:fixed; inset:0; background:rgba(0,0,0,.4); display:flex; align-items:center; justify-content:center; z-index:1050;}
.modal-container{ background:#fff; border-radius:.5rem; width:640px; max-width:95vw; box-shadow:0 10px 30px rgba(0,0,0,.25);}
.modal-header,.modal-footer{ padding:12px 16px; border-bottom:1px solid #eee; }
.modal-footer{ border-top:1px solid #eee; border-bottom:none; display:flex; gap:8px; justify-content:end; }
.modal-body{ padding:16px; }
.btn-close{ border:none; background:transparent; width:24px; height:24px; cursor:pointer; }
</style>
